export function InspectCodeItems(codeItems) {
    const codeItemResults = {
        "Success": 0,
        "Warnings": 0,
        "Errors": 0
    }

    Object.entries(codeItems).filter(item => item).map(([key, value]) => {
        if (value) {
            const cd = Object.keys(value.errors || {}).length || 0;
            const fd = Object.keys(value.warnings || {}).length || 0;
            const bd = Object.keys(value.success || {}).length || 0;


            Object.keys(value.errors || {}).length > 0 ? codeItemResults.Errors++ :
            Object.keys(value.warnings || {}).length > 0 ? codeItemResults.Warnings++ :
            codeItemResults.Success++;
        }

    });

    return codeItemResults;
};